// Creditor API — calls the local Mockoon mock server
// (apps/app/mocks/lendcord.mockoon.json, run via `pnpm mock:api`) at API_URL.
// TODO: point API_URL at the real backend once the creditor dashboard has a
// live API. Call sites elsewhere shouldn't need to change.

import { baseApi } from "@/app/store/baseApi";
import type {
  BorrowersListData,
  CreditorOverview,
  EmiRecordsData,
  EmiSummary,
  InvestorsListData,
} from "@/features/creditor/creditor.types";

export const creditorApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreditorOverview: builder.query<CreditorOverview, void>({
      query: () => ({ url: "/api/lender/creditor/overview" }),
      providesTags: ["CreditorOverview"],
    }),
    getInvestors: builder.query<InvestorsListData, void>({
      query: () => ({ url: "/api/lender/creditor/investors" }),
      providesTags: ["Investor"],
    }),
    getEmiSummary: builder.query<EmiSummary, void>({
      query: () => ({ url: "/api/lender/creditor/emi-summary" }),
      providesTags: ["EmiSummary"],
    }),
    getEmiRecords: builder.query<EmiRecordsData, void>({
      query: () => ({ url: "/api/lender/creditor/emi-records" }),
      providesTags: ["EmiRecord"],
    }),
    getBorrowers: builder.query<BorrowersListData, void>({
      query: () => ({ url: "/api/lender/creditor/borrowers" }),
      providesTags: ["Borrower"],
    }),
  }),
});

export const {
  useGetCreditorOverviewQuery,
  useGetInvestorsQuery,
  useGetEmiSummaryQuery,
  useGetEmiRecordsQuery,
  useGetBorrowersQuery,
} = creditorApi;
